export default __webpack_public_path__ + "static/media/logo.469e1e03.png";